/** 页脚外链（官网 / 合规 PDF），与 japandx.biz 约定一致 */
const ORIGIN = 'https://japandx.biz' as const

export const FOOTER_EXTERNAL = {
  /** 关于我们、联系我们 */
  company: `${ORIGIN}/#company`,
  /** 若线上实际文件名非 terms.pdf，只改此处即可 */
  // termsPdf: `${ORIGIN}/jdx/pdf/terms.pdf`,
} as const
